__turbopack_context__.v({
  "digital-text-field": "digital-text-field-module-scss-module__HeFbGG__digital-text-field",
  "digital-text-field-box": "digital-text-field-module-scss-module__HeFbGG__digital-text-field-box",
  "digital-text-field-helper-text": "digital-text-field-module-scss-module__HeFbGG__digital-text-field-helper-text",
  "digital-text-field-input": "digital-text-field-module-scss-module__HeFbGG__digital-text-field-input",
  "error": "digital-text-field-module-scss-module__HeFbGG__error",
});
